<template>
    <div class="card-body" v-if="isVisible">
        <div class="text-center">
            <label class="mt-3"><h4>{{ $t("lbl.basic.noResultMessage") }}</h4></label>
        </div>
    </div>
</template>

<script>
export default {
    name: "mmf-no-result-alert",
    data: function() {
        return {}
    },
    props: {
        isVisible: Boolean
    },
    methods: {
    }
}
</script>